import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaShoppingCart, FaPhone, FaDice, FaBookOpen, FaHome } from 'react-icons/fa';
import logo from '../img/WhiteBioEraLogo5.2_512.png';
import './Header.css';

function Header() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header>
      <nav className="navbar navbar-expand-md fixed-top">
        <div className="container-fluid">
          <Link to="/" onClick={closeMenu}><img src={logo} className="App-logo" alt="logo" /></Link>
          <button className="navbar-toggler"
            type="button"
            onClick={toggleMenu}
            aria-controls="navbarCollapse"
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarCollapse">
            <ul className="navbar-nav me-auto mb-2 mb-md-0">
              <li>
                <Link to="/" className={location.pathname === "/" ? "active" : ""} onClick={closeMenu}>Home <FaHome /></Link>
              </li>
              <li>
                <Link to="/play" className={location.pathname === "/play" ? "active" : ""} onClick={closeMenu}>Play <FaDice /></Link>
              </li>
              <li>
                <Link to="/learn" className={location.pathname === "/learn" ? "active" : ""} onClick={closeMenu}>Learn <FaBookOpen /></Link>
              </li>
              <li>
                <Link to="/collect" className={location.pathname === "/collect" ? "active" : ""} onClick={closeMenu}>
                  Collect <FaShoppingCart />
                </Link>
              </li>
              <li>
                <Link to="/contact" className={location.pathname === "/contact" ? "active" : ""} onClick={closeMenu}>
                  Contact <FaPhone />
                </Link>
              </li>
              <li>
                <Link to="/about" className={location.pathname === "/about" ? "active" : ""} onClick={closeMenu}>About Us</Link>
              </li>
            </ul>
            {/* <form className="d-flex" role="search">
              <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
              <button className="btn btn-outline-warning" type="submit">Search</button>
            </form> */}
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
